export default "__VITE_ASSET__CnHAFcfk__"